export function handleNavigation() {
    let $body = $('body');

    $body.on('click', '.js-mobile-navigation', function () {
        $body.toggleClass('show-navigation');
        return false;
    }).on('click', '.js-book-now-btn, .navigation__item--201 .navigation__link, .footer-nav__item--201 .footer-nav__link', function () {
        $body.addClass('modal-active');
        $('.js-book-now').addClass('modal--active');
        $body.toggleClass('show-navigation');

        return false;
    }).on('click', '.js-close-modal', function () {
        $body.removeClass('modal-active');
        $('.js-book-now').removeClass('modal--active');
    }).on('click', '.js-sub-nav-toggle', function () {
        $(this).toggleClass('sub-nav-toggle--active').next('.sub-nav').toggleClass('sub-nav--active').slideToggle();
        return false;
    });
}
